import React from 'react';
import { connect } from 'react-redux';

import BCLStyledNavLink from '../common/Buttons/BCLStyledNavLink';
import BCLNavMenu from '../common/Buttons/BCLNavMenu';
import { withGetScreen } from 'react-getscreen';
import { DASHBOARD_HOME_PATH, DASHBOARD_INSIGHTS_BASE_PATH, DASHBOARD_RECOMMENDATIONS_PATH, DASHBOARD_SURVEY_PATH, DASHBOARD_SETTINGS_PATH, DASHBOARD_FAQS_PATH, DASHBOARD_SOLAR_PATH, DASHBOARD_HOME_ADVISOR_PATH, DASHBOARD_MARKETPLACE_PATH } from "../../constants/paths";
import { SCREEN_BREAKPOINTS } from "../../constants/common";
import { Configuration } from '../../configs/Configuration';

class TopNavigation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuItems: [],
      isTabletView: false,
      isMobileView: false
    };
    this.configColors = Configuration.getColors().colors;
    this.getWindowSize = this.getWindowSize.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.getWindowSize);
    this.getWindowSize();
    this.setMenuItems();
  }

  setMenuItems() {
    const menuItemsToShow = this.props.configs.data && this.props.configs.data["dashboard.top_menu_items"] ? JSON.parse(this.props.configs.data["dashboard.top_menu_items"]): [];
    let allMenuItems = [
      {
        id: "HOME",
        icon: "bidgely-icon-home",
        to: DASHBOARD_HOME_PATH,
        name: null
      },
      {
        id: "ENERGY_INSIGHTS",
        icon: "bidgely-icon-energy-insight",
        to: DASHBOARD_INSIGHTS_BASE_PATH,
        name: null
      },
      {
        id: "MY_RECOMMENDATIONS",
        icon: "bidgely-icon-recommendation",
        to: DASHBOARD_RECOMMENDATIONS_PATH,
        name: null
      },
      {
        id: "SURVEY",
        icon: "bidgely-icon-survey",
        to: DASHBOARD_SURVEY_PATH,
        name: null
      },
      {
        id: "SETTINGS_AND_PREFERENCES",
        icon: "bidgely-icon-setting",
        to: DASHBOARD_SETTINGS_PATH,
        name: null
      },
      {
        id: "FAQS",
        icon: "bidgely-icon-faq",
        to: DASHBOARD_FAQS_PATH,
        name: null
      },
      {
        id: "SOLAR",
        icon: "bidgely-icon-setting", //Sarang to modify icon
        to: DASHBOARD_SOLAR_PATH,
        name: null
      },
      {      
        id: "HOME_ADVISOR",
        icon: "bidgely-icon-setting", //Satya need to modify icon
        to: DASHBOARD_HOME_ADVISOR_PATH,
        name: null
      },
      {
        id: "MARKETPLACE",
        icon: "bidgely-icon-marketplace",
        to: DASHBOARD_MARKETPLACE_PATH,
        name: null
      }
    ];

    let menuItems = [];

    if (this.props.translationsData.data) {
      for (let i = 0; i < allMenuItems.length; i++) {
        let menu = allMenuItems[i];
        menu.name = this.props.translationsData.data["TOP_MENU_ITEMS." + menu.id];
        // show only configured menu items
        if (menuItemsToShow.indexOf(menu.id) > -1) {
            menuItems.push(menu);
        }
      }
      this.setState({ menuItems: menuItems });
    }
  }

  getWindowSize() {
    this.setState({
      isMobileView: (SCREEN_BREAKPOINTS.MOBILE >= window.innerWidth),
      isTabletView: (SCREEN_BREAKPOINTS.TABLETS >= window.innerWidth)
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.getWindowSize);
  }

  render() {
    return (
      <>
        <div className="top-nav">
          <div className="btn-wrapper">
            {this.state.menuItems.map((item, index) => (
              <BCLStyledNavLink key={index} name={item.name} icon={item.icon} to={item.to} translationData={this.props.translationsData.data} unviewedRecos={this.props.recommendationsData.unviewedRecos} configColors={this.configColors}/>
            ))}
          </div>
        </div>
        { (this.state.menuItems.length > 3 || this.state.isMobileView || this.state.isTabletView) ? (
          <div className="hamburger-menu">
            <BCLNavMenu itemList={this.state.menuItems} configColors={this.configColors}/>
          </div>
        ) : ''
        }
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    translationsData: state.translationsData,
    recommendationsData: state.recommendationsData,
    configs: state.configs
  };
};

const options = {mobileLimit: 468, tabletLimit: 1034};
export default connect(mapStateToProps)(withGetScreen(TopNavigation, options));
